import React, { forwardRef } from 'react';

import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  description: {
    color: theme.palette.text.secondary,
    maxWidth: 420,
  },
  root: {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: theme.spacing(1),
    justifyContent: 'center',
    padding: theme.spacing(4, 3),
    textAlign: 'center',
    width: '100%',
  },
  title: {
    fontWeight: 600,
  },
}));

/**
 * Shown when the thread query failed for a reason other than the thread being
 * gone. Deliberately not `NotFoundState`: that one is final and sends the user
 * away, while this is a transient failure worth retrying, so the panel keeps
 * its header and the user keeps their place.
 *
 * Forwards a ref because the chat panel renders it inside a scroll container
 * that measures its content.
 */
export const ChatLoadErrorState = forwardRef<HTMLDivElement>(
  function ChatLoadErrorState(_props, ref): JSX.Element {
    const { classes } = useStyles();

    return (
      <div ref={ref} className={classes.root}>
        <Typography className={classes.title}>Couldn&apos;t load this chat</Typography>
        <Typography className={classes.description}>
          Something went wrong on our end. Reload the page to try again.
        </Typography>
      </div>
    );
  }
);
